module.exports = __webpack_public_path__ + "static/media/icon-diary.a23d9bfa.png";